module.exports = __webpack_public_path__ + "static/media/medforce.50ff02ab.png";